import React from 'react';
import { Resource } from 'store/resource/types';
import { NoResults } from 'components/no-result';
import { useSearchParams } from 'hooks/use-search-params.hook';
import { FlexContent } from 'pages/resources/content/flex-content';
import { InfiniteContent } from 'pages/resources/content/infinite-content';
import { useAppInstanceConfigFeature } from 'hooks/use-app-instance-config-feature.hook';
import { useSelector } from 'react-redux';
import { selectHasMoreInfiniteResources, selectInfiniteResources } from 'store/resources/selectors';

export interface ContentProps {
  resources: Array<Resource>;
  scrollContainerRef: React.MutableRefObject<HTMLDivElement>;
}

export const Content = ({ resources, scrollContainerRef }: ContentProps): JSX.Element => {
  const { isCompactUiEnabled } = useAppInstanceConfigFeature();
  const { floorPlanRedirection } = useSearchParams();
  const hasMoreInfiniteResources = useSelector(selectHasMoreInfiniteResources);
  const infiniteResources = useSelector(selectInfiniteResources);
  const hasResources = isCompactUiEnabled
    ? Object.values(infiniteResources).flat()?.length > 0 || hasMoreInfiniteResources
    : resources?.length > 0;

  const getContent = () => {
    if (isCompactUiEnabled) {
      return <InfiniteContent scrollContainerRef={scrollContainerRef} />;
    }
    return <FlexContent />;
  };

  return hasResources || +floorPlanRedirection ? getContent() : <NoResults />;
};
